<template>
  <div class="page">
    <div class="row">
      <div class="sm-12">
        <div class="box-page">
          <router-view @updated="updated"></router-view>
          <div class="no-print">
            <div class="row">
              <div class="sm-12">
                <div class="title">
                  <i class="mdi mdi-barcode"></i>
                  <h2>Segunda Via do Boleto</h2>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="sm-12 md-4" v-if="blocos.length != 0">
                <label>
                  Bloco
                  <select v-model="codigo_bloco">
                    <option value>Bloco</option>
                    <option v-for="bloco in blocos" :key="bloco.codigo" :value="bloco.codigo">
                      BLOCO {{ bloco.codigo }}
                    </option>
                  </select>
                </label>
              </div>
              <div class="sm-12 md-4" v-if="unidades.length != 0">
                <label>
                  Unidade
                  <select v-model="codigo_unidade">
                    <option value>Unidade</option>
                    <option :value="unidade.codigo" v-for="unidade in unidades" :key="unidade.codigo">
                      {{ unidade.descricao }}
                    </option>
                  </select>
                </label>
              </div>
              <div class="sm-12 md-4">
                <label>
                  Tipo de Doc
                  <select v-model="tipo_doc" v-if="relacao && relacao.sistema == 'C'">
                    <option value="">Tipo de Doc</option>
                    <option value="C">Condomínio Mensal</option>
                    <option value="G">Condomínio Mensal Agrupado</option>
                    <option value="E">Chamada Extra</option>
                    <option value="X">Parcela de Acordo</option>
                  </select>
                  <select v-model="tipo_doc" v-if="relacao && relacao.sistema == 'A'">
                    <option value="">Tipo de Doc</option>
                    <option value="A">Aluguel Mensal</option>
                    <option value="RS">Mês da Rescisão</option>
                    <option value="X">Parcela de Acordo</option>
                  </select>
                </label>
              </div>
              <div class="sm-12 md-4">
                <label>
                  Somente Vencidos
                  <select v-model="somente_vencidos">
                    <option :value="0">Não</option>
                    <option :value="1">Sim</option>
                  </select>
                </label>
              </div>
              <div class="sm-12 md-4">
                <label>
                  Vencimento De
                  <input type="date" v-model="vencimento_inicio" />
                </label>
              </div>
              <div class="sm-12 md-4">
                <label>
                  Vencimento Até
                  <input type="date" v-model="vencimento_fim" />
                </label>
              </div>
              <div class="sm-12 md-12 lg-8">
                <div class="row">
                  <div class="sm-12">&nbsp;</div>
                </div>
                <div class="row">
                  <div class="sm-12 md-4">
                    <button class="button secondary full" v-if="loading">
                      Buscando...
                    </button>
                    <button class="button secondary" @click="loadData" v-else>
                      Buscar
                    </button>
                  </div>
                  <div class="sm-12 md-4" v-if="boletos && boletos.length > 0">
                    <button class="button secondary full print-button visible-md" @click="print">
                      Imprimir
                    </button>
                  </div>
                  <div class="sm-12 md-4" v-if="boletos && boletos.length > 0">
                    <button class="button secondary full print-button visible-md" @click="exportar">
                      Exportar
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <div class="row" v-if="loading">
              <div class="sm-12">
                <p class="text-center">
                  <i class="mdi mdi-loading mdi-spin mdi-48px"></i>
                </p>
              </div>
            </div>
            <div class="row" v-else-if="null === boletos">
              <div class="sm-12">
                <p class="text-center" v-if="constantes.SEGUNDA_VIA_TEXTO_LISTA"
                  v-html="constantes.SEGUNDA_VIA_TEXTO_LISTA"></p>
              </div>
            </div>
            <div class="row" v-else-if="boletos && boletos.length == 0">
              <div class="sm-12">
                <p class="text-center">Nenhum boleto encontrado.</p>
              </div>
            </div>
            <div class="row" v-else-if="boletos && boletos.length != 0">
              <div class="sm-12">
                <p v-if="relacao && relacao.sistema == 'C'">CONDOMÍNIO</p>
                <p v-else-if="relacao && relacao.sistema == 'A'">IMÓVEL</p>
                <BoletosAgrupados @updated="() => loadBoletos(false)" :boletos="boletos" :sistema="relacao.sistema">
                </BoletosAgrupados>
                <!--
                        <Boleto :boleto="boleto" @updated="(boleto) => loadBoletos(false)" v-for="boleto in boletos"
                            :key="boleto.codigo"></Boleto>
                    -->
              </div>
            </div>

            <div class="row" v-if="boletos">
              <div class="sm-12" v-if="relacao && relacao.sistema == 'C'">
                <hr class="mt-16 mb-16" />

                <!--
                    <p>Tipos de Doc: C - Condomínio Mensal G - Condomínio Mensal Agrupado (Contém valores referentes a mais de uma unidade) E - Chamada Extra X - Parcela de Acordo</p>
                    <p>
                        Relacionados acima apenas os boletos disponíveis para emissão através do site.
                        A relação acima não representa um extrato de débitos. Para verificação de demais boletos pendentes, favor contatar diretamente seu(ua) acessor(a).
                    </p>
                    <p>Os valores acima não contemplam honorários advocatícios, custas judiciais, e demais valores incidentes sobre boletos que encontram-se em cobrança judicial e/ou extrajudicial.</p>
                    -->
                <p>
                  Tipos de Doc: C - Condomínio Mensal G - Condomínio Mensal Agrupado (Contém valores referentes a mais de uma unidade) E - Chamada Extra X - Parcela de Acordo
                </p>
                <p>
                  Os dados acima se referem exclusivamente aos boletos disponíveis para emissão através do site. 
                  <b>Esta lista não representa um extrato completo de débitos. </b>
                  Para verificar boletos pendentes ou inadimplência, por favor, entre em contato diretamente com seu(a) Gerente de Contas.
                </p>
              </div>
              <div class="sm-12" v-if="relacao && relacao.sistema == 'A'">
                <hr class="mt-16 mb-16" />

                <!--
                    <p>Tipos de Doc: C - Condomínio Mensal G - Condomínio Mensal Agrupado (Contém valores referentes a mais de uma unidade) E - Chamada Extra X - Parcela de Acordo</p>
                    <p>
                        Relacionados acima apenas os boletos disponíveis para emissão através do site.
                        A relação acima não representa um extrato de débitos. Para verificação de demais boletos pendentes, favor contatar diretamente seu(ua) acessor(a).
                    </p>
                    <p>Os valores acima não contemplam honorários advocatícios, custas judiciais, e demais valores incidentes sobre boletos que encontram-se em cobrança judicial e/ou extrajudicial.</p>
                    -->
                <p>
                  Tipos de Doc: A - Aluguel Mensal, RS - Mês da Rescisão, X -
                  Parcela de Acordo
                </p>
                <p>
                   Os dados acima se referem exclusivamente aos boletos disponíveis para emissão através do site. 
                  <b>Esta lista não representa um extrato completo de débitos. </b>
                  Para verificar boletos pendentes ou inadimplência, por favor, entre em contato diretamente com seu(a) Gerente de Contas.
                </p>
                <p>
                  Os valores acima não contemplam honorários advocatícios,
                  custas judiciais, e demais valores incidentes sobre boletos
                  que encontram-se em cobrança judicial e/ou extrajudicial.
                </p>
              </div>
            </div>
          </div>
          <div class="print" v-if="boletos && boletos.lenght != 0">
            <div class="row">
              <div class="sm-12">
                <h2 style="text-align: center; text-transform: uppercase">
                  Segunda Via do Boleto
                </h2>
              </div>
            </div>
            <div class="row">
              <div class="sm-12">
                <table>
                  <thead>
                    <tr>
                      <th>Bloco</th>
                      <th>Unidade</th>
                      <th>Tipo DOC</th>
                      <th>Somente Vencidos</th>
                      <th>Vencimento De</th>
                      <th>Vencimento Até</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td align="center">{{ bloco != "" ? bloco : "-" }}</td>
                      <td align="center">
                        {{ unidade != "" ? unidade : "-" }}
                      </td>
                      <td align="center">
                        {{ tipo_doc != "" ? tipo_doc : "-" }}
                      </td>
                      <td align="center">
                        {{ somente_vencidos ? "Sim" : "Não" }}
                      </td>
                      <td align="center" v-if="vencimento_inicio != ''">
                        {{ vencimento_inicio | date }}
                      </td>
                      <td align="center" v-else>-</td>

                      <td align="center" v-if="vencimento_fim != ''">
                        {{ vencimento_fim | date }}
                      </td>
                      <td align="center" v-else>-</td>
                    </tr>
                  </tbody>
                </table>
                <hr />
              </div>
            </div>
            <div class="row">
              <div class="sm-12">
                <BoletosAgrupadosPrint :boletos="boletos" :sistema="relacao.sistema"></BoletosAgrupadosPrint>
                <!--
                    <table>
                        <tbody v-for="boleto in boletos" :key="boleto.codigo">
                            <tr>
                                <td align="center" colspan="5">
                                    <span v-if="boleto.unidade">
                                        {{ boleto.unidade.condominio.endereco.enderecoCompleto }}
                                    </span>
                                    <span v-if="boleto.imovel">
                                        {{ boleto.imovel.endereco.enderecoCompleto }}
                                    </span>
                                </td>
                            </tr>
                            <tr>
                                <td align="center" v-if="boleto.unidade" rowspan="2">
                                    <strong>Unidade</strong><br />
                                    {{ boleto.unidade.descricao }}
                                </td>
                                <td align="center" v-if="boleto.imovel" rowspan="2">
                                    <strong>Unidade</strong><br />
                                    {{ boleto.imovel.subcodigo }} -
                                    {{ boleto.imovel.filial.abrev }}
                                </td>

                            </tr>
                            <tr>


                                <td align="center">
                                    <b>Vencimento</b><br />
                                    {{ boleto.dataVencimento | date }}
                                </td>
                                <td align="center">
                                    <b>Valor</b><br />
                                    {{ boleto.valorAtualizado | number_format }}
                                </td>
                                <td align="center">
                                    <b>Mês</b><br />
                                    {{ boleto.competencia }}
                                </td>
                                <td align="center">
                                    <b>Tipo DOC</b><br />
                                    {{ boleto.tipoDOC }}
                                </td>
                            </tr>

                        </tbody>
                    </table>
                -->
              </div>
            </div>

            <div class="sm-12" v-if="relacao && relacao.sistema == 'C'">
              <hr class="mt-16 mb-16" />

              <!--
                    <p>Tipos de Doc: C - Condomínio Mensal G - Condomínio Mensal Agrupado (Contém valores referentes a mais de uma unidade) E - Chamada Extra X - Parcela de Acordo</p>
                    <p>
                        Relacionados acima apenas os boletos disponíveis para emissão através do site.
                        A relação acima não representa um extrato de débitos. Para verificação de demais boletos pendentes, favor contatar diretamente seu(ua) acessor(a).
                    </p>
                    <p>Os valores acima não contemplam honorários advocatícios, custas judiciais, e demais valores incidentes sobre boletos que encontram-se em cobrança judicial e/ou extrajudicial.</p>
                    -->
              <p>
                Tipos de Doc: C - Condomínio Mensal G - Condomínio Mensal
                Agrupado (Contém valores referentes a mais de uma unidade) E -
                Chamada Extra X - Parcela de Acordo
              </p>
              <p>
                Relacionados acima apenas os boletos disponíveis para emissão
                através do site. A relação acima não representa um extrato de
                débitos. Para verificação de demais boletos pendentes, favor
                contatar diretamente seu(ua) assessor(a)
              </p>
            </div>
            <div class="sm-12" v-if="relacao && relacao.sistema == 'A'">
              <hr class="mt-16 mb-16" />
              <p>
                Tipos de Doc: A - Aluguel Mensal, RS - Mês da Rescisão, X -
                Parcela de Acordo
              </p>
              <p>
                Relacionados acima apenas os boletos disponíveis para emissão
                através do site. A relação acima não representa um extrato de
                débitos. Para verificação de demais boletos pendentes, favor
                contatar diretamente seu(ua) assessor(a)
              </p>
              <p>
                Os valores acima não contemplam honorários advocatícios, custas
                judiciais, e demais valores incidentes sobre boletos que
                encontram-se em cobrança judicial e/ou extrajudicial.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import api from "/plugins/api";
import Boleto from "./item-lista.vue";
import { boleto_service } from "../../../store/boletos";
import BoletosAgrupados from "./_components/boletos-agrupados.vue";
import BoletosAgrupadosPrint from "./_components/boletos-agrupados-print.vue";
import { watch } from "vue";

export default {
  components: {
    Boleto,
    BoletosAgrupados,
    BoletosAgrupadosPrint,
  },
  data() {

    let vencimento_fim = new Date()
    vencimento_fim.setMonth(vencimento_fim.getMonth() + 1)
    vencimento_fim.setDate(0)

    return {
      codigo_bloco: "",
      codigo_unidade: "",
      tipo_doc: "",
      somente_vencidos: 0,
      vencimento_inicio: (new Date()).toJSON().substring(0, 7)+'-01',
      vencimento_fim: vencimento_fim.toJSON().substring(0,10),

      boletos: null,
      errors: [],
      loading: false,
      constantes: {},
      view_key: Date.now(),
    };
  },
  filters: {
    number_format(value) {
      return new Intl.NumberFormat("pt-BR", {
        style: "currency",
        currency: "BRL",
      }).format(value);
    },
  },
  methods: {
    print() {
      window.print();
    },
    updated() {
      this.loadBoletos();
      this.view_key = Date.now();
    },
    async loadConstantes() {
      let { data } = await api.get("/constantes");
      this.constantes = data.reduce((acc, row) => {
        acc[row.chave] = row.valor;
        return acc;
      }, {});
    },
    async loadBoletos(esvaziar = true) {
      try {
        let params = {};
        if (this.condominio) {
          params.codigo_condominio = +this.condominio.codigo;
          if ("" != this.codigo_bloco) {
            params.bloco = this.codigo_bloco;
          }
          if ("" != this.codigo_unidade) {
            params.codigo_unidade = +this.codigo_unidade;
          }
        }
        if (this.imovel) {
          params.codigo_imovel = +this.imovel.codigo;
        }
        params.tipo_sistema = this.relacao.sistema;
        params.tipo_relacao = this.relacao.tipoRelacao;
        params.tipo_doc = this.tipo_doc;
        params.somente_vencidos = this.somente_vencidos;
        params.vencimento_inicio = this.vencimento_inicio;
        params.vencimento_fim = this.vencimento_fim;

        if (esvaziar) {
          this.boletos = [];
        }
        let { data: boletos } = await api.get("boletos", {
          params,
        });

        if (boletos && !(boletos instanceof Array)) {
          boletos = [boletos];
        }

        boletos.sort((a, b) => {
          if ("undefined" != typeof a.unidade) {
            if (a.unidade.descricao == b.unidade.descricao) {
              return a.dataVencimento < b.dataVencimento ? 1 : -1;
            }
            return a.unidade.descricao < b.unidade.descricao ? -1 : 1;
          } else if ("undefined" != typeof a.imovel) {
            let ta = `${a.imovel.subcodigo} - ${a.imovel.filial.abrev}`;
            let tb = `${b.imovel.subcodigo} - ${b.imovel.filial.abrev}`;
            if (ta == tb) {
              return a.dataVencimento < b.dataVencimento ? 1 : -1;
            }
            return ta < tb ? -1 : 1;
          }
        });

        this.boletos = boletos;
      } catch (err) {
        this.errors = [...this.errors, err];
        console.error(err);
      }
    },
    async loadData() {
      this.loading = true;
      this.errors = [];
      await this.loadBoletos();

      this.loading = false;
    },
    async exportar() {
      let blob = await boleto_service.exportToExcel(this.boletos);
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.target = "_blank";
      a.download = blob.name;
      a.click();
    },
  },
  computed: {
    bloco() {
      if (this.codigo_bloco == "") {
        return "";
      }
      return `BLOCO ${this.codigo_bloco}`;
    },
    unidade() {
      if (this.codigo_unidade == "") {
        return "";
      }

      let unidade = this.unidades.find(u => u.codigo == this.codigo_unidade);
      if (!unidade) {
        return "";
      }

      return unidade.descricao;
    },
    relacao() {
      return this.$store.getters.relacao;
    },
    condominio() {
      return this.$store.getters.condominio;
    },

    codigo_condominio() {
      if (!this.condominio) {
        return null;
      }
      return this.condominio.codigo;
    },
    blocos() {
      if ("undefined" === typeof this.condominio) {
        return [];
      }
      if ("undefined" === typeof this.condominio.blocos) {
        return [];
      }
      let blocos = this.condominio.blocos;
      if ("undefined" != typeof blocos.bloco) {
        blocos = blocos.bloco;
      }
      if (Object.values(blocos).length == 0) {
        blocos = [];
      }
      if (!(blocos instanceof Array)) {
        blocos = [blocos];
      }
      return blocos;
    },
    unidades() {
      if ("undefined" === typeof this.condominio) {
        return [];
      }
      if ("undefined" === typeof this.condominio.unidades) {
        return [];
      }
      let unidades = this.condominio.unidades;
      if (Object.values(unidades).length == 0) {
        return [];
      }
      if (!(unidades instanceof Array)) {
        unidades = [unidades];
      }
      if ("" != this.codigo_bloco) {
        unidades = unidades.filter(({ descricao }) => {
          let regex = new RegExp(`BLOCO ${this.codigo_bloco}$`, "igm");
          return regex.test(descricao);
        });
      }
      return unidades;
    },
    imovel() {
      return this.$store.getters.imovel;
    },
    codigo_imovel() {
      if (!this.imovel) {
        return 0;
      }
      if (!this.imovel.codigo) {
        return 0;
      }
      return +this.imovel.codigo;
    },
  },
  watch: {
    codigo_condominio: {
      immediate: true,
      handler() {
        this.codigo_bloco = "";
        this.codigo_unidade = "";
        //this.loadData();
      },
    },
    codigo_imovel: {
      immediate: true,
      handler() {
        if (this.codigo_imovel != 0) {
          this.loadData();
        }
      },
    },
    codigo_bloco() {
      this.codigo_unidade = "";
    },
    vencimento_inicio(new_value, old_value) {      
      let [ano, mes, dia] = new_value.split('-')
      this.vencimento_inicio = `${ano}-${mes}-01`
      /*
      const fim = new Date(ano, mes - 1, 1)
      fim.setMonth(fim.getMonth() + 1)
      fim.setDate(0)
      this.vencimento_fim = fim.toJSON().substring(0, 10)
      */

    },
    vencimento_fim(new_value, old_value) {      
      let [ano, mes, dia] = new_value.split('-')
      //this.vencimento_inicio = `${ano}-${mes}-01`
      const fim = new Date(ano, mes-1, 1)
      fim.setMonth(fim.getMonth() + 1)
      fim.setDate(0)
      this.vencimento_fim = fim.toJSON().substring(0, 10)
    }
  },
  async created() {
    this.loadConstantes();
    if (
      this.$route &&
      this.$route.query &&
      this.$route.query.origem &&
      this.$route.query.origem == "site"
    ) {
      let vinculos = this.$store.getters.vinculos.map(({ codigo }) => codigo);
      if (0 == vinculos.length) {
        return;
      }
      vinculos.sort((a, b) => {
        return a == "C" ? -1 : 1;
      });
      let [vinculo_id] = vinculos;

      let relacoes = this.$store.state.relacoes.filter(
        ({ sistema }) => sistema == vinculo_id
      );
      if (relacoes.lenght == 0) {
        return;
      }
      relacoes.sort((a, b) => {
        if (a.tipoRelacao == "P") {
          return -2;
        }
        if (a.tipoRelacao == "I") {
          return -1;
        }
        return 1;
      });
      let [relacao] = relacoes;

      if (vinculo_id == "C") {
        let condominios = [...relacao.condominios];
        if (condominios.length == 0) {
          return;
        }
        condominios.sort((a, b) => (a.abrev < b.abrev ? -1 : 1));
        let [condominio] = condominios;
        await this.$store.dispatch("setVinculoId", vinculo_id);
        let relacao_id = this.$store.getters.relacoes.findIndex(
          ({ uid }) => uid == relacao.uid
        );
        await this.$store.dispatch("setRelacaoId", relacao_id);
        let condominio_id = this.$store.getters.condominios.findIndex(
          ({ codigo }) => condominio.codigo
        );
        await this.$store.dispatch("setCondominioId", condominio_id);
      } else {
        let contratos = [...relacao.contratos].sort((a, b) => {
          return a.imovel.endereco.enderecoCompleto <
            b.imovel.endereco.enderecoCompleto
            ? -1
            : 1;
        });
        let imoveis = [...relacao.imoveis].sort((a, b) => {
          return a.endereco.enderecoCompleto < b.endereco.enderecoCompleto
            ? -1
            : 1;
        });
        if (contratos.length == 0 && imoveis.length == 0) {
          return;
        }

        await this.$store.dispatch("setVinculoId", vinculo_id);
        let relacao_id = this.$store.getters.relacoes.findIndex(
          ({ uid }) => uid == relacao.uid
        );
        await this.$store.dispatch("setRelacaoId", relacao_id);

        if (contratos.length != 0) {
          let [contrato] = contratos;
          let contrato_id = this.$store.getters.contratos.findIndex(
            ({ uid }) => uid == contrato.uid
          );
          await this.$store.dispatch("setContratoId", contrato_id);
        }
        if (imovel.length != 0) {
          let [imovel] = imoveis;
          let imovel_id = this.$store.getters.imoveis.findIndex(
            ({ codigo }) => codigo == imovel.codigo
          );
          await this.$store.dispatch("setImovelId", imovel_id);
        }
      }
    }
    await this.loadData();
  },
};
</script>
<style lang="less">
@import "../../../css/colors.less";

h4 {
  font-size: 14px;
  color: #06233d;
  margin-bottom: 10px;
}

h5 {
  font-size: 13px;
  color: #06233d;
  margin: 0;
  text-transform: uppercase;
}

h6 {
  color: #06233d;
  font-size: 12px;
  margin-bottom: 5px;
}

hr {
  border: 0;
  border-bottom: 1px solid var(--grey);
}

.w-100 {
  width: 100%;
}

.color-primary {
  color: var(--primary);
}

.p-16 {
  padding: 12px;
}

.mb-4 {
  margin-bottom: 4px;
}

.mt-16 {
  margin-top: 16px;
}

.mb-16 {
  margin-bottom: 16px;
}

.rounded {
  border-radius: 0.25em;
  overflow: hidden;
}

.bg-grey {
  background-color: var(--grey);
}

.bg-light-grey {
  background-color: var(--light-grey);
}

.flex {
  .col {
    width: 25%;
    min-width: 75px;
  }
}

small {
  span {
    font-size: inherit;
  }
}

p {
  text-align: justify;
}
</style>
